// src/views/FicheProjet/FicheProjet.js
import React, { useState, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
// import { APP_ROUTES } from "../../utils/constants";
import CollapseItem from "../../components/Collaps/Collaps";
import Tag from "../../components/Tag/Tag";
import { useUser } from "../../lib/customHooks";
import { deleteProjet, getProjet } from "../../lib/common";
import Carousel from "../../components/Carousel/Carousel";
import "./FicheProjet.scss";

// useParams = hook utilisé pour extraire les paramètres de l'URL dans un composant fonctionnel. Ici on veut récupérer notamment les "pictures" du projet
// et on se repèrera avec l'id du projet

const FicheProjet = ({ projets }) => {
  // Récupérer les informations du projet, grace è l'ID de URL et le data.json
  const { id } = useParams();
  // const projet = projets.find((projet) => projet.id === id);
  const { auth } = useUser(); // On utilise le customHook useUser pour obtenir l'état d'authentification
  const [projetsState, setProjetsState] = useState(projets);
  const [deleted, setDeleted] = useState(false);
  const [projet, setProjet] = useState(null);

  useEffect(() => {
    const fetchProjetDetails = async () => {
      try {
        const projetDetails = await getProjet(id); // Utilise getProjet pour récupérer le projet par ID
        setProjet(projetDetails);
      } catch (error) {
        console.error("Error fetching projet details:", error);
      }
    };

    fetchProjetDetails();
  }, [id]);

  const handleDelete = async (id) => {
    try {
      await deleteProjet(id);
      setProjetsState(projetsState.filter((projet) => projet.id !== id));
      setDeleted(true);
    } catch (error) {
      console.error("Error deleting projet:", error);
    }
  };

  const confirmDelete = () => {
    const confirmation = window.confirm(
      "Êtes-vous sûr(e) de vouloir supprimer ce projet ?",
    );
    if (confirmation) {
      handleDelete(id, projet.imageUrl);
    }
  };
  if (deleted) {
    return <Navigate to="/" />;
  }
  if (!projet) {
    return <p>Chargement...</p>;
  }

  const { title, description, skills, tags, githubUrl, imageUrl } = projet;
  const imagesCarousel = [
    { src: imageUrl, alt: title },
    ...(projet.carouselImages || []),
  ];
  console.log("imagesCarousel =", imagesCarousel);
  return (
    <main className="container fiche-projet">
      {/* TITRE */}
      <h1 className="TitreProjet">{title}</h1>

      {/* BOUTONS ADMIN */}
      {auth && (
        <div className="BoutonsModifierSupprimer">
          <Link to={`/projet/modifier/${projet.id}`} className="edit_button">
            Modifier
          </Link>

          <button className="delete_button" onClick={confirmDelete}>
            Supprimer
          </button>
        </div>
      )}

      {/* DESCRIPTION */}
      <section className="description">
        <p>{description}</p>
      </section>

      {/* CARROUSEL (temporairement image simple) */}
      <section className="carousel">
        <Carousel images={imagesCarousel} />
      </section>

      {/* STACK TECHNIQUE */}
      <section className="stack">
        <h2>Stack technique</h2>
        <Tag tags={tags} />
      </section>

      {/* COMPETENCES */}
      <section className="competences">
        <CollapseItem
          title="Compétences"
          content={
            <ul>
              {skills.map((skill, index) => (
                <li key={index}>{skill}</li>
              ))}
            </ul>
          }
        />
      </section>

      {/* GITHUB */}
      {githubUrl && (
        <div className="github-link">
          <a href={githubUrl} target="_blank" rel="noopener noreferrer">
            Voir sur GitHub
          </a>
        </div>
      )}
    </main>
  );
};

export default FicheProjet;
